import { APIURL, getData, postData } from "../fetch";


/**
 * 
 * @typedef {{
 *  id: string 
 *  feenote_id: string
 *  amount: number
 *  payment_date: string
 *  feenote: string|import("./fee-notes").NoteObject
 *  date_added: string
 *  added_by: string 
 *  date_updated: string 
 *  updated_by: string 
 * }} PaymentObject
 */


/**
 * 
 * @param {PaymentObject} data 
 * @returns {Promise<{code: number, message: string, payment: PaymentObject}>}
 */
const createPayment = data => {
    return postData({
        url: `${APIURL}/payments`,
        data
    })
}

/**
 * 
 * @param {PaymentObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, payment: PaymentObject}>}
 */
const updatePayment = (data, id) => {
    return postData({
        url: `${APIURL}/payments/${id}`,
        data
    })
}

/**
 * 
 * @param {boolean} getAll If to get the expanded list  
 * @returns {Promise<{code: number, message: string, payments: PaymentObject[]}>}
 */
const getPayments = (getAll = false) => {

    const obj = { url: `${APIURL}/payments` }

    if (getAll) obj.data = { expanded: 1 }

    return getData(obj)

}


/**
 * 
 * @param {string} id 
 * @param {string[]|null} includes 
 * @returns  {Promise<{code: number, message: string, payment: PaymentObject}>}
 */
const getPayment = (id, includes = null) => {

    const obj = { url: `${APIURL}/payments/${id}` };

    if (includes) obj.data = { include: includes.join(",") };

    return getData(obj);
}


/**
 * 
 * @param {string} id 
 * @returns  {Promise<{code: number, message: string}>}
 */
const deletePayment = id => getData({ url: `${APIURL}/payments/${id}`, method: "DELETE" })


export {
    createPayment,
    getPayment,
    getPayments,
    updatePayment,
    deletePayment
}